import { tryDeriveEndpointName } from '@vl-core/getApiEndpoint';
import ServiceApi from 'vl-common/src/services/service.api';

const endpoint = tryDeriveEndpointName();
const url = `https://${endpoint}api.virtuallucyweb.co.uk/v1`;

export const getArticleNo = (category) => {
  return async () => {
    return await fetch(`${url}/outputs/confluence/APPUSER/${category}`);
  };
};
export const fetchArticle = (article) => {
  return async () => {
    return await ServiceApi.get(`/article/${article}`);
  };
};

export const fetchArticleFromDB = (article) => {
  return async () => {
    const res = await ServiceApi.get(`/outputs/template/html?user_guid=APPUSER&template_code=${article}`);
    console.log('res', res);
    return res;
  };
};

export const fetchArticleNoAuth = (article) => {
  return async () => {
    const res = await fetch(`${url}/article/${article}`);
    return await res.json();
  };
};
export const fetchArticleNoAuthFromDB = (article) => {
  return async () => {
    const res = await fetch(`${url}/content/${article}`);
    return await res.json();
  };
};
